import React from "react";
import FormList from "./FormList";
import TextInput from "./element/TextInput";
import DeleteButton from "./element/DeleteButton";
import AddButton from "./element/AddButton";

function FormLists({ id, list, updateData, addData, removeData }) {
  function handleTitleChange(e) {
    updateData({
      mainId: id,
      newValue: e.target.value,
      category: "leftColumnTitle",
    });
  }
  function handleAdd(e) {
    addData({ category: "list" + e.target.name, mainId: id });
  }
  function handleDelete() {
    removeData({ category: "formList", mainId: id });
  }

  function pickHeader(proficiency) {
    switch (proficiency) {
      case "none":
        return "Basic List";
      case "level":
        return "Proficiency List";
      case "score":
        return "Skillbar List";
      default:
        break;
    }
  }

  return (
    <>
      <div className="mb-4">
        <div className="flex items-center mb-2 gap-4">
          <p className="text-base font-semibold">
            {pickHeader(list.proficiencyType)}{" "}
          </p>
          <DeleteButton handleDelete={handleDelete} />
        </div>
        <div className="mb-2">
          <div className="mb-4">
            {" "}
            <TextInput
              labelText="Title:"
              inputName="name"
              inputOnChange={handleTitleChange}
              inputValue={list.name}
            />{" "}
          </div>
          {list.items.map((item, index) => {
            return (
              <FormList
                key={item.id}
                itemId={index}
                proficiencyType={list.proficiencyType}
                item={item}
                listId={id}
                updateData={updateData}
                removeData={removeData}
              />
            );
          })}
        </div>
        <AddButton
          handleAdd={handleAdd}
          name={list.proficiencyType}
          text={"+ list item"}
        />
      </div>
    </>
  );
}

export default FormLists;
